import { render } from "./TraitRanksUtilityCard.vue?vue&type=template&id=265aafd2"
import script from "./TraitRanksUtilityCard.vue?vue&type=script&lang=js"
export * from "./TraitRanksUtilityCard.vue?vue&type=script&lang=js"

import "./TraitRanksUtilityCard.vue?vue&type=style&index=0&id=265aafd2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__